import React from 'react';
import PageContainer from 'shared-components/PageContainer/PageContainer';
import styles from './EmptyFavorites.module.css';

const EmptyFavorites = () => (
  <PageContainer className={styles.emptyFavoritesContainer}>
    <i className="fal fa-heart" />
    <p>No Items Favorited Yet</p>
    <p>Click on the heart icon to save anything you love.</p>
  </PageContainer>
);

export default EmptyFavorites;
